import React from 'react';
import { Field, Input, Label, Description } from '@headlessui/react';
import clsx from 'clsx';

interface FormFieldProps {
  id: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'url' | 'number' | 'tel' | 'password';
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  required?: boolean;
  description?: string;
  placeholder?: string;
  className?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  id,
  name,
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
  description,
  placeholder,
  className,
}) => {
  return (
    <Field className={className}>
      <Label className="text-base font-semibold text-slate-700 mb-2 block">
        {label} {required && '*'}
      </Label>
      {description && (
        <Description className="text-sm text-slate-600 mb-2 block leading-relaxed">
          {description}
        </Description>
      )}
      <Input
        id={id}
        name={name}
        type={type}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        required={required}
        placeholder={placeholder}
        className={clsx(
          'border border-slate-300 block w-full rounded-lg bg-white py-3 px-4 text-base shadow-sm',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
          'transition duration-150 ease-in-out'
        )}
      />
      {touched && error ? (
        <div className="text-red-700 text-sm mt-2 bg-red-50 border border-red-200 p-2 rounded">
          {error}
        </div>
      ) : null}
    </Field>
  );
};

export default FormField;
